const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      tabs: '.js-tabs',
      item: '.js-tabs-item',
      content: '.js-tabs-content',
      title: '.js-tabs-content-title',
    };

    this.classes = {
      active: 'is-active',
    };

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    this.showFirstTab();
    this.initTabs();
    this.initAccordion();
  }

  showFirstTab() {
    $(this.selectors.tabs).each((index, tab) => {
      const $tabs = $(tab);
      const id = $tabs
        .find(this.selectors.item)
        .first()
        .attr('href');

      if (id) {
        this.switchTab(id.slice(1), $tabs);
      }
    });
  }

  initTabs() {
    $(this.selectors.item).on('click', event => {
      event.preventDefault();
      const $item = $(event.currentTarget);
      const $tabs = $item.parents(this.selectors.tabs);
      const id = $item.attr('href').substr(1);

      this.switchTab(id, $tabs);
    });
  }

  switchTab(id, $tabs) {
    this.clearTabs($tabs);
    $(`${this.selectors.item}[href="#${id}"]`)
      .addClass(this.classes.active)
      .attr('aria-selected', 'true');
    $(`#${id}`)
      .addClass(this.classes.active)
      .attr('aria-expanded', 'true');
  }

  clearTabs($tabs) {
    $tabs
      .find(this.selectors.item)
      .removeClass(this.classes.active)
      .attr('aria-selected', 'false');
    $tabs
      .find(this.selectors.content)
      .parent()
      .removeClass(this.classes.active)
      .attr('aria-expanded', 'false');
  }

  initAccordion() {
    $(this.selectors.title).on('click', event => {
      event.preventDefault();
      const $item = $(event.currentTarget);
      const $tabs = $item.parents(this.selectors.tabs);
      const $parent = $item.parent();
      const id = $parent.attr('id');

      this.switchTab(id, $tabs);
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/tabs.js